(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3614],{

/***/ 7314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Minus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M5 12h14", key: "1ays0h" }]];
const Minus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("minus", __iconNode);


//# sourceMappingURL=minus.js.map


/***/ }),

/***/ 31012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Plus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
];
const Plus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("plus", __iconNode);


//# sourceMappingURL=plus.js.map


/***/ }),

/***/ 37133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/legal-hub",
      function () {
        return __webpack_require__(38766);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const CLMHero2 = (param)=>{
    let { CLMHeroData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "max-w-screen-xl mx-auto text-black relative mb-5 md:mb-24 md:mt-16 md:mt-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 flex flex-col items-center justify-start md:gap-6 px-4 md:px-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center justify-center gap-6 md:gap-7 mt-8 w-full ",
                        children: [
                            CLMHeroData.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-2xl text-violet-600 uppercase",
                                children: CLMHeroData.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-5xl leading-[48px] md:text-[72px] md:leading-[72px] text-center max-w-full md:w-[95%] xl:w-[90%] font-semibold",
                                children: CLMHeroData.heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg font-medium text-gray-800 md:text-2xl text-center md:w-[80%]",
                                children: CLMHeroData.description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .CLMButtonPrimary */ .IS, {
                                buttonText: CLMHeroData.btnText,
                                buttonUrl: CLMHeroData.btnUrl
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-xl md:mx-8 mx-auto pt-8",
                        children: [
                            CLMHeroData.video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: CLMHeroData.video,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl",
                                autoPlay: true,
                                loop: true,
                                muted: true
                            }),
                            CLMHeroData.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: CLMHeroData.image,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CLMHero2);


/***/ }),

/***/ 8129:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);


const CTASection = (param)=>{
    let { btnText , btnUrl  } = param;
    return /*#__PURE__*/ _jsxs("section", {
        className: "bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "text-4xl md:text-7xl font-semibold leading-snug md:mt-20 mt-4 max-w-screen-xl mx-auto mb-16 tracking-tight",
                children: "Transform service with BoloSign's AI agent platform"
            }),
            /*#__PURE__*/ _jsx(CLMButtonPrimary, {
                buttonText: btnText,
                buttonUrl: btnUrl
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CTASection)));


/***/ }),

/***/ 74791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function FaqItem(param) {
    let { question , answer , isOpen , onToggle  } = param;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onToggle,
        className: "px-8 py-7 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: answer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
}
function FaqList(param) {
    let { faqs  } = param;
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs.map((faq, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ".concat(openIndex === index ? "" : "hover:bg-surface-dark", " transition-all  duration-300"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                    question: faq === null || faq === void 0 ? void 0 : faq.question,
                    answer: faq === null || faq === void 0 ? void 0 : faq.answer,
                    isOpen: openIndex === index,
                    onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                }, index)
            }, index);
        })
    });
}
const FAQ2 = (param)=>{
    let { faqData , heading , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:w-[920px] max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl font-semibold leading-snug mb-8",
                children: heading
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqList, {
                faqs: faqData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ2);


/***/ }),

/***/ 39669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


const ProactiveCard = (param)=>{
    let { title , desc , videoSrc ="" , imgSrc ="" , isImageRight =true , bgColor ="bg-white"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col md:flex-row gap-8 md:gap-12  ".concat(bgColor),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 text-start flex flex-col justify-center items-center ".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-800", " ").concat(isImageRight ? "md:order-1" : "md:order-2"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-4xl md:text-5xl font-semibold mb-4 md:mb-8",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-lg font-medium ".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-600", " md:text-2xl md:mb-9"),
                        children: desc
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: " ".concat(isImageRight ? "md:order-2" : "md:order-1", " flex-1"),
                children: [
                    videoSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        src: videoSrc,
                        alt: "ai-agent",
                        width: 500,
                        height: 500,
                        className: "rounded-xl w-full",
                        autoPlay: true,
                        loop: true,
                        muted: true
                    }),
                    imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: imgSrc,
                        alt: "ai-agent",
                        width: 500,
                        height: 500,
                        className: "rounded-xl  w-full"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProactiveCard);


/***/ }),

/***/ 38766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ legal_hub; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/CLM/CaseStudyCard/index.jsx



const TestimonialCard = (param)=>{
    let { logo , desc , subHead , bgColor , image  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "px-6 md:px-8 xl:px-28",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " max-w-screen-xl mx-auto my-12 md:my-32 text-black md:rounded-2xl flex flex-col md:flex-row justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full md:w-2/3 mb-6 md:mb-0 md:pr-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: logo,
                                alt: "Headout Logo",
                                width: 170,
                                height: 170
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-2xl md:text-3xl font-bold mb-4 xl:mb-8 ",
                                children: desc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-6 text-sm md:text-xl ",
                                children: subHead
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col xl:gap-3 sm:flex-row sm:space-x-8 text-center sm:text-left hidden md:flex mt-10 xl:mt-32",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-4 sm:mb-0 max-w-[30%]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-5xl mb-2 text-indigo-600 font-semibold",
                                                children: "60%"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "",
                                                children: "Decrease in contract handling time for legal teams"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-4 sm:mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-5xl mb-2 text-indigo-600 font-semibold",
                                                children: "900+"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "",
                                                children: "Digital agreements signed using BoloSign"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-5xl mb-2 text-indigo-600 font-semibold whitespace-nowrap",
                                                children: "1-2 days"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "",
                                                children: "To fully onboard new partners"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full md:w-1/3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image,
                            alt: "Customer discussion",
                            width: 500,
                            height: 500,
                            className: "w-full h-full"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-2 gap-5 md:hidden py-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-4 sm:mb-0 md:max-w-[30%]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-2xl md:text-5xl md:mb-2",
                                        children: "60%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm",
                                        children: "Decrease in contract handling time for legal teams"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-4 sm:mb-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-2xl md:text-5xl md:mb-2",
                                        children: "900+"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm",
                                        children: "Digital agreements signed using BoloSign"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-2xl md:text-5xl md:mb-2",
                                        children: "1-2 days"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm",
                                        children: "To fully onboard new partners"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CaseStudyCard = (TestimonialCard);

// EXTERNAL MODULE: ./components/CLM/CLMHero2/index.jsx
var CLMHero2 = __webpack_require__(29937);
// EXTERNAL MODULE: ./components/CLM/CTASection/index.jsx
var CTASection = __webpack_require__(8129);
// EXTERNAL MODULE: ./components/CLM/FAQ2/index.jsx
var FAQ2 = __webpack_require__(74791);
// EXTERNAL MODULE: ./components/CLM/ProactiveCard/index.jsx
var ProactiveCard = __webpack_require__(39669);
// EXTERNAL MODULE: ./components/CLM/v3/Buttons.jsx
var Buttons = __webpack_require__(56475);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
;// CONCATENATED MODULE: ./pages/clm/legal-hub/index.jsx










const CLMHeroData = {
    // title: "Reporting",
    heading: "Empower legal teams for managing online terms",
    description: "Easily organize, edit, and publish your website’s terms and policies—all from one place.",
    image: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/legalhub-header-1.png"),
    btnText: "Review a contract for free",
    btnUrl: "/clm/request-demo"
};
const threeCards = [
    {
        img: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/legal-hub-effortless.webp"),
        alt: "filter-by",
        desc: "Draft, edit, and format online terms in a familiar interface—just like Word or Google Docs.",
        title: "Effortless editing experience"
    },
    {
        img: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/legal-hub-identify-2.png"),
        alt: "expiry-is",
        desc: "Deliver tailored terms by grouping them by product, region, or customer type.",
        title: "Identifying the right terms"
    },
    {
        img: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/legal-hub-one-click-copy.png"),
        alt: "custom-view",
        desc: "Capture legally binding agreement instantly, with version tracking and audit trails built-in.",
        title: "One-click legal consent"
    }
];
const legalHubFaqData = [
    {
        question: "What is BoloSign Legal Hub?",
        answer: "BoloSign Legal Hub is your centralized workspace for publishing and managing standard agreements online. It gives legal and operations teams complete oversight, making it easy to organize, update, and distribute documents across departments."
    },
    {
        question: "How quickly can I deploy the Legal Hub?",
        answer: "You can get your Legal Hub live within minutes. It's easy to configure with your brand’s logo, colors, and domain—no need for extensive dev support or long implementation timelines."
    },
    {
        question: "How does the Legal Hub support agreement management?",
        answer: "With BoloSign Legal Hub, you can maintain all agreement versions in one place, edit terms as needed, and ensure every stakeholder always sees the most current version—without chasing down other teams."
    },
    {
        question: "Can I connect BoloSign Legal Hub with other tools or web pages?",
        answer: "Absolutely. You can embed your agreements across multiple touchpoints—whether it’s a sign-up page, app flow, or footer—so legal documents are always accessible where your users need them."
    },
    {
        question: "What are some standout capabilities of BoloSign Legal Hub?",
        answer: "From a Microsoft Word-like editor to smart filtering by region or product line, BoloSign lets you present the right contracts to the right users. It also allows single-click acceptance and version tracking—streamlining everything from rollout to audit."
    },
    {
        question: "Who is BoloSign Legal Hub built for?",
        answer: "It’s designed for legal and operations teams at scaling companies that want more control over contract workflows—without slowing down product, marketing, or customer teams."
    },
    {
        question: "How does BoloSign ensure contract compliance and integrity?",
        answer: "BoloSign tracks every change with built-in version control and maintains an audit history of all interactions. That means your contracts stay current, compliant, and provably secure—every step of the way."
    }
];
// function ProactiveCard({
//   title,
//   desc,
//   videoSrc,
//   imgSrc,
//   isImageRight = true,
//   bgColor = "bg-white",
// }) {
//   return (
//     <div
//       className={`flex flex-col md:flex-row gap-8 md:gap-12 md:my-12 ${bgColor}`}
//     >
//       <div
//         className={`flex-1 text-start flex flex-col justify-center items-center ${
//           bgColor == "bg-black" ? "text-white" : "text-gray-800"
//         } ${isImageRight ? "md:order-1" : "md:order-2"}`}
//       >
//         <h2 className="text-4xl md:text-5xl font-semibold mb-4 md:mb-8">
//           {title}
//         </h2>
//         <p
//           className={`text-lg font-medium ${
//             bgColor == "bg-black" ? "text-white" : "text-gray-600"
//           } md:text-2xl md:mb-9`}
//         >
//           {desc}
//         </p>
//       </div>
//       <div className={` ${isImageRight ? "md:order-2" : "md:order-1"} flex-1`}>
//         {videoSrc && (
//           <video
//             src={videoSrc}
//             alt="ai-agent"
//             width={500}
//             height={500}
//             className={`rounded-xl w-full`}
//             autoPlay
//             loop
//             muted
//           />
//         )}
//         {imgSrc && (
//           <Image
//             src={imgSrc}
//             alt="ai-agent"
//             width={500}
//             height={500}
//             className={`rounded-xl  w-full`}
//           />
//         )}
//       </div>
//     </div>
//   );
// }
const LegalHub = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Legal Hub - BoloSign CLM"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Centralize, manage, and publish your online terms with BoloSign Legal Hub—designed for legal teams to maintain compliance and control."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "BoloSign Legal Hub, online terms management, contract lifecycle management, CLM legal hub, centralized policy management, legal document publishing, contract compliance, legal operations tools"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/clm/legal-hub/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CLMHero2/* default */.Z, {
                CLMHeroData: CLMHeroData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-start md:text-center bg-cream py-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-4xl md:text-5xl font-semibold mb-6 px-6 md:px-0",
                        children: "Full ownership of your digital policies"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xl lg:w-[70%] xl:w-[60%] mx-auto px-6 md:px-0",
                        children: "With BoloSign, legal teams can create, update, and publish terms—all in one place, no tech help needed."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-dark",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-screen-xl md:px-8 px-6 mx-auto py-16 md:py-32 text-gray-900 text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProactiveCard/* default */.Z, {
                        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/legal-hub-legal.png"),
                        title: "Update terms instantly—no follow-ups needed",
                        desc: "Make changes to your terms or agreements whenever you want. BoloSign saves each version automatically—no need to wait on marketing or dev teams.",
                        isImageRight: false,
                        bgColor: "bg-dark"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-screen-xl md:px-8 px-6 mx-auto pt-16 md:pt-32 text-gray-900 text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProactiveCard/* default */.Z, {
                        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/legal-hub-royal.png"),
                        title: "One central hub for every policy and update",
                        desc: "Easily manage, publish, and access all your legal terms from a single dashboard—so your users always see the latest version.",
                        isImageRight: true,
                        bgColor: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-transparent",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-screen-xl md:px-8 px-6 mx-auto pt-16 md:pt-32 text-gray-900 text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProactiveCard/* default */.Z, {
                        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/legal-hub-launch.png"),
                        title: "Launch your branded legal hub in minutes",
                        desc: "Set up your own policy center with BoloSign, fully customized to match your brand—no dev work or long setup required.",
                        isImageRight: false,
                        bgColor: "bg-transparent"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-screen-xl md:px-8 px-6 mx-auto py-16 md:py-32 text-gray-900 text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProactiveCard/* default */.Z, {
                        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/legal-hub-clickwrap.png"),
                        title: "Embed online terms wherever they matter most",
                        desc: "Add your online terms to contracts, sign-up flows, or footers—making them accessible, compliant, and crystal clear across all touchpoints.",
                        isImageRight: true,
                        bgColor: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center bg-dark text-white md:py-24 py-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-4xl md:text-5xl mb-6",
                        children: "Why teams choose BoloSign legal hub"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xl md:text-2xl lg:w-[70%] xl:w-[60%] mx-auto max-w-screen-lg mx-auto px-6 md:px-0",
                        children: "BoloSign lets you draft, edit, and review contracts using Microsoft Word’s interface—plus advanced tools built for legal teams."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "text-black py-24 px-6 md:px-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-screen-xl xl:px-8 mx-auto flex flex-col md:flex-row gap-12 justify-between items-end",
                    children: threeCards.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " flex flex-col items-center justify-between gap-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-2xl font-semibold mb-1",
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base mb-3",
                                            children: item.desc
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: item.img,
                                    alt: item.alt,
                                    width: 300,
                                    height: 300,
                                    className: "w-full h-full "
                                })
                            ]
                        }, index))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center bg-dark text-white py-24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-4xl md:text-5xl mb-8 max-w-screen-xl mx-auto md:px-24",
                        children: "Discover how BoloSign helps legal teams to manage online terms effortlessly"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMButtonPrimary */.IS, {
                        buttonText: "Request a quick demo",
                        buttonUrl: "/clm/request-demo",
                        className: "w-fit mx-auto"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudyCard, {
                logo: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/legal-hub-logo.webp"),
                desc: "“We had contracts ready, but no centralized place to manage or share them”",
                subHead: "Jane Roberts, Legal Operations Lead, Rethink Electric",
                bgColor: "bg-transparent",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/legal-hub-laptop-in-hand-1.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ2/* default */.Z, {
                    faqData: legalHubFaqData,
                    heading: "FAQs"
                })
            })
        ]
    });
};
/* harmony default export */ var legal_hub = (LegalHub);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(37133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);